import React, { useState } from "react";
import Collapsible from "react-collapsible";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./collapsible.css";
import { ExpandLessOutlined } from "@mui/icons-material";

interface Props {
  triggerText?: string;
  boldText?: string;
  open?: boolean;
}

const Collapse: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  triggerText,
  boldText,
  open,
}) => {
  const [isOpen, setIsOpen] = useState(open ? open : false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const trigger = (
    <div
      className="collapsible-trigger"
      onClick={isOpen ? handleClose : handleOpen}
    >
      {triggerText ? <h4>{triggerText}</h4> : <h4>{boldText}</h4>}
      <div
        className={`trigger_icon ${isOpen ? "open" : ""}`}
        onClick={isOpen ? handleClose : handleOpen}
      >
        {!isOpen ? (
          <ExpandMoreIcon fontSize="medium" />
        ) : (
          <ExpandLessOutlined fontSize="medium" />
        )}
      </div>
    </div>
  );

  return (
    <Collapsible open={isOpen} transitionTime={100} trigger={trigger}>
      {children}
    </Collapsible>
  );
};

export default Collapse;
